export const SUCCESS = 'SUCCESS';
export const ALERT = 'ALERT';
export const BLOCK = 'BLOCK';
